import React from 'react';
import {
  //LocalOffer as LocalOfferIcon,
  Person as ProfileIcon,
  //Notifications as NotificationsIcon,
  Security as SecurityIcon,
  List as MuiListIcon,
  FormatListBulleted as FormatListBulletedIcon,
  Apps as AppsIcon,
  Window as WindowIcon,
  X,
  Instagram,
  Language,
  SquareRounded as LargeBoxIcon,
  LocalFireDepartment as BurnIcon,
  StarBorder,
  HorizontalSplit as ItemsIcon,
  TrendingUp as AnalyticsIcon,
  SyncAlt as ActivityIcon,
  People as HoldersIcon,
  AccessTime as AccessTimeIcon,
  Add as CreateIcon,
} from '@mui/icons-material';
import { PiGavelFill as BidsIcon } from 'react-icons/pi';

import { Link, Box, styled } from '@mui/material';

import {
  MenuDiscordIcon,
  MenuTwitterIcon,
  MenuInstagramIcon,
  MenuRedditIcon,
  MenuYouTubeIcon,
  OfferIcon,
  TransferIcon,
  MintedIcon,
  SaleIcon,
  ListIcon,
  BidIcon,
  DiscordNewIcon,
  MetamaskIcon,
  CoinBaseIcon,
  EthNewIcon,
  ApeChainSymbolNew,
  ArbitrumSymbolNew,
  MonadSymbolFilled,
  BaseSymbol,
  AbstractSymbol,
  BinanceSymbol,
  NRGChromeIcon,
  LiquidityBondsIconWhite,
} from 'components/ImageComponent';
import { Profile, /*Notifications,*/ /*Offers,*/ AccountSupport } from 'pages/Settings/components';

export const APP_VERSION = 'v3.0.0';

// Width for Filter side bar drawer
export const DRAWER_WIDTH = '360px';

export const ENERGI_SUPPORT_LINK =
  'https://discord.com/channels/398355554172534805/1157987899246137384';

const LINK_GMI_DOCS = 'https://docs.gonnamakeit.com/';

// closing time after leave menu
export const MENU_CLOSING_TIME = 100;

export const SIGNATURE_EXPIRY_TIME = 604800000; // 7 days

export const BUILD_MODE = process.env.REACT_APP_BUILD_MODE || 'Mainnet';

export const NETWORK = {
  1: {
    symbol: 'ETH',
    wrapped: 'WETH',
    maxDecimals: 4,
    priceApiKey: 'ethereum',
  },
  11155111: {
    symbol: 'ETH',
    wrapped: 'WETH',
    maxDecimals: 4,
    priceApiKey: 'ethereum',
  },
  39797: {
    symbol: 'NRG',
    wrapped: 'WNRG',
    maxDecimals: 2,
    priceApiKey: 'energi',
  },
  49797: {
    symbol: 'NRG',
    wrapped: 'WNRG',
    maxDecimals: 2,
    priceApiKey: 'energi',
  },
  33139: {
    symbol: 'APE',
    wrapped: 'WAPE',
    maxDecimals: 2,
    priceApiKey: 'apecoin',
  },
  33111: {
    symbol: 'APE',
    wrapped: 'WAPE',
    maxDecimals: 2,
    priceApiKey: 'apecoin',
  },
  42161: {
    symbol: 'ETH',
    wrapped: 'WETH',
    maxDecimals: 4,
    priceApiKey: 'ethereum',
  },
  421614: {
    symbol: 'ETH',
    wrapped: 'WETH',
    maxDecimals: 4,
    priceApiKey: 'ethereum',
  },
  143: {
    symbol: 'MON',
    wrapped: 'WMON',
    maxDecimals: 2,
    priceApiKey: 'monad',
  },
  10143: {
    symbol: 'MON',
    wrapped: 'WMON',
    maxDecimals: 2,
    priceApiKey: 'monad',
  },
  8453: {
    symbol: 'ETH',
    wrapped: 'WETH',
    maxDecimals: 4,
    priceApiKey: 'ethereum',
  },
  84532: {
    symbol: 'ETH',
    wrapped: 'WETH',
    maxDecimals: 4,
    priceApiKey: 'ethereum',
  },
  2741: {
    symbol: 'ETH',
    wrapped: 'WETH',
    maxDecimals: 4,
    priceApiKey: 'ethereum',
  },
  11124: {
    symbol: 'ETH',
    wrapped: 'WETH',
    maxDecimals: 4,
    priceApiKey: 'ethereum',
  },
  56: {
    symbol: 'BNB',
    wrapped: 'WBNB',
    maxDecimals: 4,
    priceApiKey: 'binancecoin',
  },
  97: {
    symbol: 'tBNB',
    wrapped: 'WBNB',
    maxDecimals: 4,
    priceApiKey: 'binancecoin',
  },
};

export const CONFIG = {
  Testnet: {
    ETHEREUM_CHAIN_ID: 11155111, // Sepolia
    ENERGI_CHAIN_ID: 49797,
    APECHAIN_CHAIN_ID: 33111, // Curtis
    ARBITRUM_CHAIN_ID: 421614, // Arbitrum Sepolia
    MONAD_CHAIN_ID: 10143, // Monad Testnet
    BASE_CHAIN_ID: 84532, // Base Sepolia
    ABSTRACT_CHAIN_ID: 11124, // Abstract Testnet
    BINANCE_CHAIN_ID: 97,
  },
  Mainnet: {
    ETHEREUM_CHAIN_ID: 1,
    ENERGI_CHAIN_ID: 39797,
    APECHAIN_CHAIN_ID: 33139,
    ARBITRUM_CHAIN_ID: 42161,
    MONAD_CHAIN_ID: 143,
    BASE_CHAIN_ID: 8453,
    ABSTRACT_CHAIN_ID: 2741, // Abstract Mainnet
    BINANCE_CHAIN_ID: 56,
  },
};

export const SUPPORTED_NETWORKS = {
  Energi: CONFIG[BUILD_MODE].ENERGI_CHAIN_ID,
  Ethereum: CONFIG[BUILD_MODE].ETHEREUM_CHAIN_ID,
  ApeChain: CONFIG[BUILD_MODE].APECHAIN_CHAIN_ID,
  Arbitrum: CONFIG[BUILD_MODE].ARBITRUM_CHAIN_ID,
  Monad: CONFIG[BUILD_MODE].MONAD_CHAIN_ID,
  Base: CONFIG[BUILD_MODE].BASE_CHAIN_ID,
  Abstract: CONFIG[BUILD_MODE].ABSTRACT_CHAIN_ID,
  Bsc: CONFIG[BUILD_MODE].BINANCE_CHAIN_ID,
};

// LP Bonds Exchange Proxy addresses for fractionalization
export const LP_BONDS_EXCHANGE_PROXY_ADDRESS = {
  1: '0x28A8DEeF322128F275A9BE845643BA4B46189Cc7', // Ethereum Mainnet
  33139: '0x28A8DEeF322128F275A9BE845643BA4B46189Cc7', // ApeChain
  42161: '0x28A8DEeF322128F275A9BE845643BA4B46189Cc7', // Arbitrum Mainnet
  143: '0x28A8DEeF322128F275A9BE845643BA4B46189Cc7', // Monad Mainnet
  8453: '0x28A8DEeF322128F275A9BE845643BA4B46189Cc7', // Base Mainnet
  2741: '0x28A8DEeF322128F275A9BE845643BA4B46189Cc7', // Abstract Mainnet
  56: '0x28A8DEeF322128F275A9BE845643BA4B46189Cc7', // Binance Mainnet
  97: '0x28A8DEeF322128F275A9BE845643BA4B46189Cc7', // Binance Testnet
};

export const NETWORK_NAME = {
  1: 'Ethereum',
  11155111: 'Sepolia',
  39797: 'Energi',
  49797: 'Energi Testnet',
  33139: 'ApeChain',
  33111: 'Curtis',
  42161: 'Arbitrum',
  421614: 'Arbitrum Sepolia',
  143: 'Monad',
  10143: 'Monad Testnet',
  8453: 'Base',
  84532: 'Base Sepolia',
  2741: 'Abstract',
  11124: 'Abstract Testnet',
  56: 'BSC',
  97: 'BSC Testnet',
  default: 'Default Network',
};

export const BALANCE_TOKEN_LIST = [
  // =============================================================================
  // NATIVE TOKENS - Chain native currencies (displayed first in wallet)
  // =============================================================================
  {
    symbol: 'ETH',
    name: 'Ether',
    chains: [1, 11155111, 42161, 421614, 8453, 84532, 2741, 11124],
    isNative: true,
    decimals: 18,
  },
  {
    symbol: 'NRG',
    name: 'Energi',
    decimals: 18,
    chains: [1, 11155111, 39797, 49797],
    isNative: true, // Native on Energi chains, ERC20 where addresses are specified
    addresses: {
      1: '0x1416946162b1c2c871a73b07e932d2fb6c932069', // NRG token on Ethereum mainnet
      11155111: '0xc85d4367eB56dDc56E96A56E003A0514b41a70cE', // NRG token on Sepolia testnet
      // No addresses for 39797, 49797 means it's native on those chains
    },
  },
  {
    symbol: 'APE',
    name: 'ApeCoin',
    decimals: 18,
    chains: [33139, 33111, 42161, 421614],
    isNative: true, // Native on ApeChain, ERC20 on Arbitrum where addresses are specified
    addresses: {
      42161: '0x7f9fbf9bdd3f4105c478b996b648fe6e828a1e98', // APE token on Arbitrum mainnet
      421614: '0x7f9fbf9bdd3f4105c478b996b648fe6e828a1e98', // APE token on Arbitrum Sepolia testnet
    },
  },
  {
    symbol: 'MON',
    name: 'Monad',
    decimals: 18,
    chains: [143], // Monad Mainnet
    isNative: true,
  },
  {
    symbol: 'BNB',
    name: 'Binance Coin',
    decimals: 18,
    chains: [56, 97], // Binance chains
    isNative: true,
  },

  // =============================================================================
  // WRAPPED TOKENS - Wrapped versions of native currencies
  // =============================================================================
  {
    symbol: 'WETH',
    name: 'Wrapped Ethereum',
    decimals: 18,
    chains: [1, 11155111, 42161, 421614, 8453, 84532, 2741, 11124],
    isWrapped: true,
    addresses: {
      1: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
      11155111: '0x7b79995e5f793a07bc00c21412e50ecae098e7f9',
      42161: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1', // Arbitrum One WETH
      421614: '0x980b62da83eff3d4576c647993b0c1d7faf17c73', // Arbitrum Sepolia WETH
      8453: '0x4200000000000000000000000000000000000006', // Base Mainnet WETH
      84532: '0x4200000000000000000000000000000000000006', // Base Sepolia WETH
      2741: '0x3439153eb7af838ad19d56e1571fbd09333c2809', // Abstract Mainnet WETH
      11124: '0x3439153eb7af838ad19d56e1571fbd09333c2809', // Abstract Testnet WETH
    },
  },
  {
    symbol: 'WNRG',
    name: 'Wrapped Energi',
    chains: [39797, 49797],
    decimals: 18,
    isWrapped: true,
    addresses: {
      39797: '0xA55F26319462355474A9F2c8790860776a329aA4',
      49797: '0x184F7b12f29d675f34ff816528ADBfd0E0501Ad4',
    },
  },
  {
    symbol: 'WAPE',
    name: 'Wrapped ApeChain',
    decimals: 18,
    chains: [33139, 33111],
    isWrapped: true,
    addresses: {
      33139: '0x48b62137edfa95a428d35c09e44256a739f6b557',
      33111: '0x383b5827dde285761c7d8094bf974bea38bead43',
    },
  },
  {
    symbol: 'WBNB',
    name: 'Wrapped Binance Coin',
    decimals: 18,
    chains: [56, 97], // Binance chains
    isWrapped: true,
    addresses: {
      56: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c', // Binance Mainnet
      97: '0xae13d989dac2f0debff460ac112a837c89baa7cd', // Binance Testnet
    },
  },

  // =============================================================================
  // ERC20 TOKENS - GMI, stablecoins, and other tokens
  // =============================================================================
  {
    symbol: 'GMI',
    name: 'GonnaMakeIt',
    decimals: 18,
    chains: [1, 33139, 33111, 42161, 421614, 143, 8453, 84532, 2741, 11124, 56, 97],
    addresses: {
      1: '0x044e874f23f9a7e5dad696554a116c4bb62fecb7', // GMI token on Ethereum mainnet
      33139: '0x044e874f23f9a7e5dad696554a116c4bb62fecb7', // GMI token on ApeChain mainnet
      33111: '0x044e874f23f9a7e5dad696554a116c4bb62fecb7', // GMI token on ApeChain testnet (Curtis)
      42161: '0x044e874f23f9a7e5dad696554a116c4bb62fecb7', // GMI token on Arbitrum mainnet
      421614: '0x044e874f23f9a7e5dad696554a116c4bb62fecb7', // GMI token on Arbitrum Sepolia testnet
      143: '0x044e874f23f9a7e5dad696554a116c4bb62fecb7', // GMI token on Monad mainnet
      8453: '0x044e874f23f9a7e5dad696554a116c4bb62fecb7', // GMI token on Base mainnet
      84532: '0x044e874f23f9a7e5dad696554a116c4bb62fecb7', // GMI token on Base Sepolia testnet
      2741: '0xd044eb94ef1b2f8d0c859375d6d2d169d5026783', // GMI token on Abstract mainnet
      11124: '0xd044eb94ef1b2f8d0c859375d6d2d169d5026783', // GMI token on Abstract testnet
      56: '0x044e874f23f9a7e5dad696554a116c4bb62fecb7', // GMI token on Binance mainnet
      97: '0x044e874f23f9a7e5dad696554a116c4bb62fecb7', // GMI token on Binance testnet
    },
  },
  {
    symbol: 'USDT',
    name: 'Tether USD',
    decimals: 6, // Default (Ethereum)
    chainDecimals: {
      56: 18, // BSC USDT has 18 decimals
      97: 18, // BSC Testnet USDT has 18 decimals
    },
    chains: [1, 56, 97], // Ethereum mainnet and Binance chains
    addresses: {
      1: '0xdac17f958d2ee523a2206206994597c13d831ec7', // USDT token on Ethereum mainnet (6 decimals)
      56: '0x55d398326f99059ff775485246999027b3197955', // USDT token on Binance mainnet (18 decimals)
      97: '0x55d398326f99059ff775485246999027b3197955', // USDT token on Binance testnet (18 decimals)
    },
  },
  {
    symbol: 'USDC',
    name: 'USD Coin',
    decimals: 6,
    chains: [1, 8453, 84532, 42161, 421614, 33139], // Ethereum mainnet, Base, Arbitrum, and ApeChain
    addresses: {
      1: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48', // USDC token on Ethereum mainnet
      8453: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913', // USDC token on Base mainnet
      84532: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913', // USDC token on Base Sepolia testnet
      42161: '0xaf88d065e77c8cc2239327c5edb3a432268e5831', // USDC token on Arbitrum mainnet
      421614: '0xaf88d065e77c8cc2239327c5edb3a432268e5831', // USDC token on Arbitrum Sepolia (placeholder)
      33139: '0xf1815bd50389c46847f0bda824ec8da914045d14', // USDC token on ApeChain mainnet
    },
    // Contract symbol overrides for chains where it differs from display symbol
    contractSymbols: {
      33139: 'USDC.e', // ApeChain contract returns USDC.e as symbol
    },
  },
  {
    symbol: 'USDC.e',
    name: 'Bridged USDC',
    decimals: 6,
    chains: [2741, 11124],
    addresses: {
      2741: '0x84a71ccd554cc1b02749b35d22f684cc8ec987e1',
      11124: '0x84a71ccd554cc1b02749b35d22f684cc8ec987e1',
    },
  },
  {
    symbol: 'apeUSD',
    name: 'ApeChain USD',
    decimals: 18,
    chains: [33139, 33111], // ApeChain only
    addresses: {
      33139: '0xa2235d059f80e176d931ef76b6c51953eb3fbef4', // apeUSD on ApeChain mainnet
      33111: '0xa2235d059f80e176d931ef76b6c51953eb3fbef4', // apeUSD on ApeChain testnet (Curtis)
    },
  },
  {
    symbol: 'HELLO',
    name: 'Hello Labs',
    decimals: 18,
    chains: [1, 56, 97], // Ethereum mainnet and Binance chains
    addresses: {
      1: '0x411099c0b413f4feddb10edf6a8be63bd321311c', // Hello Labs HELLO token on Ethereum mainnet
      56: '0x0f1cbed8efa0e012adbccb1638d0ab0147d5ac00', // HELLO token on Binance mainnet
      97: '0x0f1cbed8efa0e012adbccb1638d0ab0147d5ac00', // HELLO token on Binance testnet
    },
  },
  {
    symbol: 'ARB',
    name: 'Arbitrum',
    decimals: 18,
    chains: [42161, 421614], // Arbitrum chains
    addresses: {
      42161: '0x912CE59144191C1204E64559FE8253a0e49E6548', // ARB token on Arbitrum mainnet
      421614: '0x912CE59144191C1204E64559FE8253a0e49E6548', // ARB token on Arbitrum Sepolia testnet (placeholder)
    },
  },
  {
    symbol: 'KIMA',
    name: 'KIMA Network',
    decimals: 18,
    chains: [42161, 421614], // Arbitrum chains
    addresses: {
      42161: '0x94fCD9c18f99538C0f7C61c5500cA79F0D5C4dab', // KIMA token on Arbitrum mainnet
      421614: '0x94fCD9c18f99538C0f7C61c5500cA79F0D5C4dab', // KIMA token on Arbitrum Sepolia testnet (placeholder)
    },
  },
];

export const DEFAULT_NETWORK = SUPPORTED_NETWORKS.Ethereum;
export const CHAIN_ID = parseInt(DEFAULT_NETWORK);
export const NETWORK_DEFAULT = NETWORK[DEFAULT_NETWORK];

// All links within marketplace and outside - handle testnet/mainnet in env?
export const LINKS_LIST = {
  allNFTs: {
    name: 'All NFTs',
    link: '',
  },
  new: {
    name: 'New',
    link: '',
  },
  art: {
    name: 'Art',
    link: '',
  },
  domainNames: {
    name: 'Domain Names',
    link: '',
  },
  virtualWorlds: {
    name: 'Virtual Worlds',
    link: '',
  },
  tradingCards: {
    name: 'Trading Cards',
    link: '',
  },
  collectibles: {
    name: 'Collectibles',
    link: '',
  },
  sports: {
    name: 'Sports',
    link: '',
  },
  utility: {
    name: 'Utility',
    link: '',
  },
  profile: {
    name: 'Profile',
    link: '',
  },
  favorites: {
    name: 'Favorites',
    link: '',
  },
  myCollectibles: {
    name: 'My Collectibles',
    link: '',
  },
  settings: {
    name: 'Settings',
    link: '',
  },
  rankings: {
    name: 'Rankings',
    link: '',
  },
  activity: {
    name: 'Activity',
    link: '',
  },
  blog: {
    name: 'Blog',
    link: '',
  },
  partners: {
    name: 'Partners',
    link: '',
  },
  website: {
    name: 'Website',
    type: 'resources',
    link: '',
  },
  documentation: {
    name: 'Docs',
    link: '',
  },
  github: {
    name: 'Github',
    link: 'https://github.com/energicryptocurrency',
    external: true,
  },
  joinOurTeam: {
    name: 'Join Our Team',
    link: 'https://www.energi.world/join-our-team/',
    external: true,
  },
  contactUs: {
    name: 'Contact Us',
    link: ENERGI_SUPPORT_LINK,
    external: true,
  },
  twitter: {
    name: 'Twitter',
    link: 'https://x.com/gonnamakeitnfts',
    external: true,
  },
  discord: {
    name: 'Discord',
    link: 'https://discord.com/invite/sCtgNC3/',
    external: true,
  },
  telegram: {
    name: 'Telegram',
    link: 'https://t.me/GonnaMakeitNFTs',
    external: true,
  },
  reddit: {
    name: 'Reddit',
    link: 'https://www.reddit.com/r/energicryptocurrency/',
    external: true,
  },
  youtube: {
    name: 'Youtube',
    link: 'https://www.youtube.com/c/Energicrypto',
    external: true,
  },
  facebook: {
    name: 'Facebook',
    link: 'https://www.facebook.com/energicrypto/',
    external: true,
  },
  instagram: {
    name: 'Instagram',
    link: 'https://www.instagram.com/energicrypto',
    external: true,
  },
  linkedin: {
    name: 'Linkedin',
    link: 'https://www.linkedin.com/company/energi-core/',
    external: true,
  },
  aboutUs: {
    name: 'About Us',
    link: 'https://www.gonnamakeit.com/',
    external: true,
  },
  terms: {
    name: 'Terms',
    link: 'tos',
  },
  docs: {
    name: 'Docs',
    link: LINK_GMI_DOCS,
    external: true,
  },
  developerDocs: {
    name: 'Developer Docs',
    link: `${LINK_GMI_DOCS}docs/developers/`,
    external: true,
  },
  faq: {
    name: 'FAQ',
    link: `${LINK_GMI_DOCS}docs/faq/`,
    external: true,
  },
  guides: {
    name: 'GMI Guides',
    link: `${LINK_GMI_DOCS}docs/guides/`,
    external: true,
  },
  privacyPolicy: {
    name: 'Privacy Policy',
    link: 'https://gonnamakeit.com/privacy-policy/',
    external: true,
  },
};

// Social media links/icons for sidebar and mobile menu
export const SOCIAL_MEDIAS = [
  {
    ...LINKS_LIST['twitter'],
    icon: <MenuTwitterIcon />,
  },
  {
    ...LINKS_LIST['instagram'],
    icon: <MenuInstagramIcon />,
  },
  {
    ...LINKS_LIST['discord'],
    icon: <MenuDiscordIcon />,
  },
  {
    ...LINKS_LIST['reddit'],
    icon: <MenuRedditIcon />,
  },
  {
    ...LINKS_LIST['youtube'],
    icon: <MenuYouTubeIcon />,
  },
];

export const NAV_MENUS = [
  {
    id: 1,
    text: 'Collections',
    path: 'https://app.gonnamakeit.com/collections?type=top',
  },
  {
    id: 2,
    text: 'LP Bonds',
    path: '/lp-bonds',
    submenu: false,
    gradient: 'lp-bonds',
  },
  {
    id: 3,
    text: 'Portfolio',
    path: '/portfolio',
    submenu: false,
  },
  {
    id: 4,
    text: 'Activity',
    path: '/activity',
    submenu: false,
  },

  {
    id: 5,
    text: 'Airdrop',
    path: 'https://airdrop.gonnamakeit.com/',
    submenu: false,
    gradient: 'airdrop',
  },
  {
    id: 6,
    text: 'Create',
    path: '/create',
    submenu: false,
    notShowInSideNav: true,
  },
  {
    id: 7,
    text: 'Resources',
    path: '',
    submenu: true,
  },
  {
    id: 8,
    text: 'Get GMI',
    path: '/get-gmi',
    submenu: false,
    isButton: true,
  },
];

// marketplace - options to sort listed cards
export const SORT_OPTIONS = [
  { name: 'Listed: Recent', value: 'lastListingTimestamp', direction: 'ascending' },
  { name: 'Listed: Oldest', value: 'lastListingTimestamp', direction: 'descending' },
  { name: 'Price: Lowest', value: 'price', direction: 'ascending' },
  { name: 'Price: Highest', value: 'price', direction: 'descending' },
];

// marketplace - options to display type of cards
export const ITEMS_OPTIONS = [
  { name: 'Items', value: 'All_items' },
  { name: 'Single items', value: 'Single_items' },
  { name: 'Bundles', value: 'Bundles' },
];

// price history - options to price history time duration
export const PRICE_HISTORY_OPTIONS = [
  '7 days',
  '14 days',
  '30 days',
  '60 days',
  '90 days',
  'Last year',
  'All time',
];

const day = 24 * 60 * 60; // A day in seconds
export const FETCH_PERIOD = {
  '7 days': 7 * day,
  '14 days': 14 * day,
  '30 days': 30 * day,
  '60 days': 60 * day,
  '90 days': 90 * day,
  'Last year': 365 * day,
  'All time': Date.now() / 1000, // 'all time' timestamp
};

// Filter option for sort by date in rankings
export const LAST_PERIOD_OPTIONS = {
  'Last 10 minutes': 600,
  'Last 1 hour': 3600,
  'Last 6 hours': 21800,
  'Last 24 hours': 86400,
  'Last 7 days': 604800,
  'Last 30 days': 2592000,
};

export const COLLECTION_VOLUMES_TIMEFRAMES = {
  'Last 1 hour': '1h',
  'Last 6 hours': '6h',
  'Last 24 hours': '24h',
  'Last 7 days': '7d',
  'Last 30 days': '30d',
};

export const DEFAULT_TIMEFRAME = '24h';

export const COLLECTIONS_COLUMNS = [
  { field: 'rank', label: '#', align: 'left' },
  { field: 'name', label: 'Collection', align: 'left' },
  { field: 'floorPrice', label: 'Floor Price' },
  { field: 'topBid', label: 'Top Bid' },
  { field: 'change24h', label: '1D Change' },
  { field: 'change7d', label: '7D Change' },
  { field: 'volume24h', label: '1D Volume' },
  { field: 'volume7d', label: '7D Volume' },
  { field: 'totalVolume', label: 'Total Volume' },
  { field: 'owners', label: 'Owners' },
  { field: 'circulatingSupply', label: 'Supply/Listed' },
];

export const SORT_NETWORKS = [
  // { value: 'overall', label: 'Overall' },
  { value: 'gmi', label: 'GonnaMakeIt' },
  // { value: 'opensea', label: 'OpenSea' },
];

// accordion details of account support
export const ACCOUNT_SUPPORT_ACCORDIONS = [
  {
    summary: 'General help',
    detail: (
      <span>
        Visit our{' '}
        <Link
          href={ENERGI_SUPPORT_LINK}
          target="_blank"
          rel="noopener noreferer"
          sx={{ lineHeight: '18px' }}
        >
          help center
        </Link>{' '}
        to learn how to get started with buying, selling, and creating.
      </span>
    ),
  },
  {
    summary: 'Contact GonnaMakeIt Support',
    detail: (
      <span>
        {"Can't find the answers you're looking for?"} <br />
        You can{' '}
        <Link
          href="https://discord.com/channels/398355554172534805/1157987899246137384"
          target="_blank"
          rel="noopener noreferer"
          sx={{ lineHeight: '18px' }}
        >
          submit a request
        </Link>{' '}
        here.
      </span>
    ),
  },
  {
    summary: 'Help with a compromised account',
    detail: (
      <span>
        If you believe your account has been compromised, let us know and we can lock your account.
        This will disable items in your wallet from being bought, sold, or transferred using
        GonnaMakeIt.{' '}
        <Link
          href={ENERGI_SUPPORT_LINK}
          target="_blank"
          rel="noopener noreferer"
          sx={{ lineHeight: '18px' }}
        >
          Learn more
        </Link>{' '}
        .
      </span>
    ),
  },
];

// compromised options for account support
export const COMPROMISED_OPTIONS = [
  { value: 1, text: 'I have unknown transactions on my account' },
  { value: 2, text: 'I have everything but believe my account is compromised' },
  { value: 3, text: 'Other' },
];

const iconTag = (ActivityIcon) => {
  return <ActivityIcon sx={{ width: 20, marginRight: 1, color: 'icon.secondary' }} />;
};

// Activity types for filter and display
export const ACTIVITY_TYPES = {
  sale: { name: 'Sale', icon: iconTag(SaleIcon) },
  listing: { name: 'List', icon: iconTag(ListIcon) },
  offer: { name: 'Offer', icon: iconTag(OfferIcon) },
  mint: { name: 'Mint', icon: iconTag(MintedIcon) },
  transfer: { name: 'Transfer', icon: iconTag(TransferIcon) },
  burn: { name: 'Burn', icon: iconTag(BurnIcon) },
  bid: { name: 'Bid', icon: iconTag(BidIcon) },
};

// Message to sign for authentication
export const AUTH_MESSAGE_TO_SIGN = (address, nonce) => {
  return `Welcome to GonnaMakeIt!\n\nClick to sign in and accept the GonnaMakeIt Terms of Service\n\nThis request will not trigger a blockchain transaction or cost any gas fees.\n\nYour authentication status will reset after 7 days.\n\nWallet address: ${address}\n\nNonce: ${nonce}`;
};

// marketplace - options to display features of card
export const CARD_OPTIONS = [
  { name: 'Refresh metadata', value: 'REFRESH_METADATA', item: 'nft' },
  { name: 'Copy link', value: 'COPY_LINK', item: 'nft' },
  { name: 'Website', value: 'WEBSITE', item: 'nft' },
  { name: 'Report this item', value: 'REPORT', item: 'nft' },
];

export const activityFilterStatusOpen = [
  { name: 'Status', active: false },
  { name: 'Collections', active: false },
];

export const CollectionFilterOpen = [
  { name: 'Status', active: false },
  { name: 'Collections', active: false },
];

export const REWARDS_TABS = [
  '/rewards/referral_program',
  '/rewards/referral_program/apply_promo',
  '/rewards/referral_program/redeem',
];

export const RESOURCE_MENU = [
  {
    text: 'Stats',
    path: '/stats',
  },
  {
    text: 'Litepaper',
    path: '/lite-paper',
  },
  {
    text: 'For Investors',
    path: 'https://gonnamakeit.com/for-investors/',
  },
  {
    text: 'FAQ',
    path: '/faq',
  },
  {
    text: 'Docs',
    path: LINK_GMI_DOCS,
  },
  {
    text: 'Help Center',
    path: ENERGI_SUPPORT_LINK,
  },
  {
    text: 'Energi Website',
    path: 'https://energi.world/',
  },
];

export const NAVBAR_MENUS = [
  {
    text: 'Collections',
    path: 'https://app.gonnamakeit.com/collections?type=top',
  },
  {
    text: 'LP Bonds',
    path: '/lp-bonds',
    tabs: ['/lp-bonds'],
  },

  {
    text: 'Portfolio',
    path: '/portfolio',
  },
  {
    text: 'Activity',
    path: '/activity',
  },

  {
    text: 'Airdrop',
    path: 'https://airdrop.gonnamakeit.com/',
  },
  {
    text: 'Resources',
    path: '',
    submenus: RESOURCE_MENU,
  },
  {
    text: 'Get GMI',
    path: '/get-gmi',
  },
];

// LP Bonds specific navigation tabs
export const LP_BONDS_SUB_NAVIGATIONS = [
  {
    text: 'LP Bonds',
    link: 'liquidity-bonds',
    icon: <LiquidityBondsIconWhite width={20} height={20} />,
  },
  {
    text: 'Favorites',
    link: 'favorites',
    icon: <StarBorder sx={{ width: '20px', height: '20px' }} />,
  },
];

export const STAT_REWARDS_SUB_NAVIGATIONS = [
  {
    text: 'Referral rewards',
    link: 'referral',
  },
  {
    text: 'Airdrop referral rewards',
    link: 'airdrop',
  },
];

export const PAGE_SIZES = [100, 50, 20];

export const REPORT_OPTIONS = [
  { label: 'Fake collection or possible scam', value: 0 },
  { label: 'Explicit or sensitive content', value: 1 },
  { label: 'Spam', value: 2 },
  { label: 'Might be stolen', value: 3 },
  { label: 'Other', value: 4 },
];

export const RAW_COLLECTION = [
  {
    name: 'Crypto Punk',
    active: false,
    show: true,
    alt: 'Avatar',
    src: 'https://i.pravatar.cc/300',
  },
  {
    name: 'Energi Special',
    active: false,
    show: true,
    alt: 'Avatar',
    src: 'https://i.pravatar.cc/300',
  },
  {
    name: 'ABC Collection',
    active: false,
    show: true,
    alt: 'Avatar',
    src: 'https://i.pravatar.cc/300',
  },
  {
    name: 'Scoppy Do',
    active: false,
    show: true,
    alt: 'Avatar',
    src: 'https://i.pravatar.cc/300',
  },
]; // dummy data - Fetch from database

export const ACCOUNT_SETTINGS = [
  {
    slug: 'profile',
    icon: <ProfileIcon />,
    text: 'Profile',
    component: <Profile />,
    path: '/account/settings/profile',
  },
  /* TODO: enable when Notifications ready
  {
    slug: 'notifications',
    icon: <NotificationsIcon />,
    text: 'Notifications',
    component: <Notifications />,
    path: '/account/settings/notifications',
  },*/
  /* TODO: enable when Bids ready
  {
    slug: 'offers',
    icon: <LocalOfferIcon />,
    text: 'Offers',
    component: <Offers />,
    path: '/account/settings/offers',
  },*/
  {
    slug: 'account_support',
    icon: <SecurityIcon />,
    text: 'Account Support',
    component: <AccountSupport />,
    path: '/account/settings/support',
  },
];

export const FILTER_BOX_MAX_HEIGHT = 80;
export const DEFAULT_SIZE = 20;

export const REDIRECT_LINK_EXPLORER = {
  1: 'https://etherscan.io',
  11155111: 'https://sepolia.etherscan.io',
  39797: 'https://explorer.energi.network',
  49797: 'https://explorer.test.energi.network',
  33139: 'https://apescan.io/',
  33111: 'https://curtis.apescan.io/',
  42161: 'https://arbiscan.io',
  421614: 'https://sepolia.arbiscan.io',
  143: 'https://monadscan.com',
  10143: 'https://testnet.monadscan.com',
  8453: 'https://basescan.org',
  84532: 'https://sepolia.basescan.org',
  2741: 'https://abscan.org/',
  11124: 'https://testnet.abscan.org/',
  56: 'https://bscscan.com',
  97: 'https://testnet.bscscan.com',
  default: '',
};

export const LINKS = {
  twitter: 'https://twitter.com/',
  instagram: 'https://instagram.com/',
};

// List id for newsletter email list on sendgrid. Need to be sent with the post request
// Type: string
export const NEWSLETTER_EMAIL_LIST_ID = '18944388';

export const REPORT_TOAST_DURATION = 4000;

export const WRAPPED_PROXY_ADDRESS = {
  1: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
  11155111: '0x7b79995e5f793a07bc00c21412e50ecae098e7f9',
  39797: '0xa55f26319462355474a9f2c8790860776a329aa4',
  49797: '0x184f7b12f29d675f34ff816528adbfd0e0501ad4',
  33139: '0x48b62137edfa95a428d35c09e44256a739f6b557',
  33111: '0x383b5827dde285761c7d8094bf974bea38bead43',
  42161: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1', // Arbitrum Mainnet
  421614: '0x980b62da83eff3d4576c647993b0c1d7faf17c73', // Arbitrum Sepolia WETH
  143: '0x760afe86e5de5fa0ee542fc7b7b713e1c5425701', // Monad Mainnet WMON address
  10143: '0x760afe86e5de5fa0ee542fc7b7b713e1c5425701', // Monad Testnet WMON address
  8453: '0x4200000000000000000000000000000000000006', // Base Mainnet WETH
  84532: '0x4200000000000000000000000000000000000006', // Base Sepolia WETH
  2741: '0x3439153eb7af838ad19d56e1571fbd09333c2809', // Abstract Mainnet WETH
  11124: '0x3439153eb7af838ad19d56e1571fbd09333c2809', // Abstract Testnet WETH
  56: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c', // Binance Mainnet WBNB
  97: '0xae13d989dac2f0debff460ac112a837c89baa7cd', // Binance Testnet WBNB
};

// ExchangeProxy contract address - indexed by chainId
export const EXCHANGE_PROXY_ADDRESS = {
  1: '0x4e992e34df70a3a903408da308bdc1349277b6cd',
  11155111: '0x69131badf12db01116251018cc1015d2ff7f4833',
  39797: '0x0D09CDb5901467FA531Aa7b1D8AC331Ab9f1F70B',
  49797: '0xc805369791fc642ff3fc624b8edfa28b7e15701f',
  33139: '0x4e992e34df70a3a903408da308bdc1349277b6cd',
  33111: '0x253ce8fd3031536e235682d1bde500aeab4bd2a7',
  42161: '0x699137bf89e9b4af7ecb503aeac8f7e41536657a', // Arbitrum Mainnet
  421614: '0x699137bf89e9b4af7ecb503aeac8f7e41536657a', // Arbitrum Sepolia
  143: '0x253ce8fd3031536e235682d1bde500aeab4bd2a7', // Monad Mainnet
  10143: '0x253ce8fd3031536e235682d1bde500aeab4bd2a7', // Monad Testnet
  8453: '0x4e992e34df70a3a903408da308bdc1349277b6cd', // Base Mainnet
  84532: '0x44eb1be12d296a52bdeee7a55479771a4799d7e7', // Base Sepolia
  2741: '0x8ec899a855a264b7f9c605f327a5f359d3fc1c2c', // Abstract Mainnet
  11124: '0x01e6dd3d7091ddc90a9af2165fb6073b417318c2', // Abstract Testnet
  56: '0x699137bf89e9b4af7ecb503aeac8f7e41536657a', // Binance Mainnet
  97: '0x699137bf89e9B4AF7ECB503AeaC8f7e41536657a', // Binance Testnet
};

export const EXCHANGE_HELPER_PROXY_ADDRESS = {
  1: '0xa46c1a4f05609c36f0389d6fc2ceb2e5ae86b487',
  11155111: '0x151448374ce04cab1bc2737c9ada6b6fcc71cf7e',
  39797: '0xA46c1A4f05609C36F0389d6fC2cEB2e5aE86b487',
  49797: '0x5d4808a0da3a2aad2315f9cdfc4a667fbb3bb68c',
  33139: '0xa46c1a4f05609c36f0389d6fc2ceb2e5ae86b487',
  33111: '0x1a40ac86bff0cfefac5ffa64acfa913887faf1f1',
  42161: '0x6647a0906dbD029Dd1D119dE28EB8f64542979e0', // Arbitrum Mainnet
  421614: '0x6647a0906dbD029Dd1D119dE28EB8f64542979e0', // Arbitrum Sepolia
  143: '0x1a40ac86bff0cfefac5ffa64acfa913887faf1f1', // Monad Mainnet
  10143: '0x1a40ac86bff0cfefac5ffa64acfa913887faf1f1', // Monad Testnet
  8453: '0xa46c1a4f05609c36f0389d6fc2ceb2e5ae86b487', // Base Mainnet
  84532: '0x189b22e18626171bc9290878dbd80f62764145c1', // Base Sepolia
  2741: '0x2c337e5e9fcc637c36f902e9d4311c63b763687b', // Abstract Mainnet
  11124: '0x7acfdf0817f5ba7cd9832562f34a72d448e92fc7', // Abstract Testnet
  56: '0x6647a0906dbd029dd1d119de28eb8f64542979e0', // Binance Mainnet
  97: '0x6647a0906dbd029dd1d119de28eb8f64542979e0', // Binance Testnet
};

// ExchangeProxy contract asset classes
export const CONTRACT_ASSET_CLASSES = {
  C_ETH: -1161908566,
  C_ETH_STR: '0xaaaebeba',
  C_WETH: 260708671,
  C_WETH_STR: '0x0f8a193f',
  C_ERC20: -2074220406,
  C_ERC20_STR: '0x8ae85d84',
  C_ERC721: 1176612211,
  C_ERC721_STR: '0x73ad2146',
  C_ERC1155: 1085684631,
  C_ERC1155_STR: '0x973bb640',
  C_V1: 1715610444,
  C_V1_STR: '0x6642234c',
  C_ff: -1,
  C_ff_STR: '0xffffffff',
};

// Zero address
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
// Dead address
export const DEAD_ADDRESS = '0x000000000000000000000000000000000000dead';

// EIP712 signer message
export const EIP712_SIGNER_MESSAGE = {
  types: {
    AssetType: [
      { name: 'assetClass', type: 'bytes4' },
      { name: 'data', type: 'bytes' },
    ],
    Asset: [
      { name: 'assetType', type: 'AssetType' },
      { name: 'value', type: 'uint256' },
    ],
    Order: [
      { name: 'maker', type: 'address' },
      { name: 'makeAsset', type: 'Asset' },
      { name: 'taker', type: 'address' },
      { name: 'takeAsset', type: 'Asset' },
      { name: 'salt', type: 'uint256' },
      { name: 'start', type: 'uint256' },
      { name: 'end', type: 'uint256' },
      { name: 'dataType', type: 'bytes4' },
      { name: 'data', type: 'bytes' },
      { name: 'collectionBid', type: 'bool' },
    ],
  },
  primaryType: 'Order',
  domain: {
    name: 'Energi',
    version: '1',
    chainId: 0, // current network chain id
    verifyingContract: '', // contract that will verify signature
  },
  message: '', // maker order
};

export const MAX_APPROVAL_AMOUNT =
  '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff';

export const SOCIAL_MEDIA_COLORS = {
  Twitter: '#1DA1F2',
  Reddit: '#FF5700',
  Facebook: '#4267B2',
  WhatsApp: '#25D366',
};

export const RESEND_EMAIL_VERIFICATION_DELAY = 60000; // 1 minute in milliseconds
export const LOCAL_STORAGE_TIMER_KEY = 'timerData';

export const ACTIVE_STEPS = {
  CALL_APPROVE: 0,
  INTERACT_METAMASK_APPROVE: 1,
  CONFIRM_TRANSACTION_APPROVE: 2,
  CALL_FUNCTION: 3,
  COMPLETE_TRANSACTION: 4,
};

export const SUPPORT_EMAIL = 'support@gonnamakeit.com';

// Files
export const FILE_MAX_SIZE = 10 * 1024 * 1024; // 10 MB

export const TOTAL_ROYALTY_PERCENTAGE = {
  MIN: 0.5,
  MAX: 7,
  MULTIPLIER: 100,
};

export const DECIMALS_REGEX = /-?\d*\.?\d{0,3}/i;

export const COLLECTION_VIEWS = [
  { value: 'condensed', icon: <MuiListIcon /> },
  { value: 'expanded', icon: <FormatListBulletedIcon /> },
];

export const BOND_COLLECTION = {
  FETCH_RESULT_LIMIT: 50,
  DEFAULT_VIEW: 'ShortList',
  CONTENT_VIEWS: {
    ShortList: <MuiListIcon />,
    BigThumbnail: <WindowIcon />,
  },
  MOBILE_CONTENT_VIEWS: {
    ShortList: <MuiListIcon />,
    LargeThumbnail: <LargeBoxIcon sx={{ fontSize: 26 }} />,
  },
  CONTENT_TABS: {
    ITEMS_TAB: {
      icon: <ItemsIcon fontSize="small" />,
      label: 'Items',
      value: 0,
    },
    BIDS_TAB: {
      icon: <BidsIcon fontSize="large" />,
      label: 'Bids',
      value: 1,
    },
    CREATE_TAB: {
      icon: <CreateIcon fontSize="small" />,
      label: 'Mint',
      value: 2,
    },
    ANALYTICS_TAB: {
      icon: <AnalyticsIcon fontSize="small" />,
      label: 'Analytics',
      value: 3,
    },
    ACTIVITY_TAB: {
      icon: <ActivityIcon fontSize="small" />,
      label: 'Activity',
      value: 4,
    },
    HOLDERS_TAB: {
      icon: <HoldersIcon fontSize="small" />,
      label: 'Holders',
      value: 5,
    },
  },
};

export const SINGLE_COLLECTION = {
  FETCH_RESULT_LIMIT: 50,
  DEFAULT_VIEW: 'BigThumbnail',
  CONTENT_VIEWS: {
    ShortList: <MuiListIcon />,
    LargeList: <FormatListBulletedIcon />,
    SmallThumbnail: <AppsIcon />,
    BigThumbnail: <WindowIcon />,
  },
  MOBILE_CONTENT_VIEWS: {
    LargeList: <FormatListBulletedIcon />,
    SmallThumbnail: <AppsIcon />,
    BigThumbnail: <WindowIcon />,
    LargeThumbnail: <LargeBoxIcon sx={{ fontSize: 26 }} />,
  },
  CONTENT_TABS: {
    ITEMS_TAB: {
      icon: <ItemsIcon fontSize="small" />,
      label: 'Items',
      value: 0,
    },
    BIDS_TAB: {
      icon: <BidsIcon fontSize="large" />,
      label: 'Bids',
      value: 1,
    },
    ANALYTICS_TAB: {
      icon: <AnalyticsIcon fontSize="small" />,
      label: 'Analytics',
      value: 2,
    },
    ACTIVITY_TAB: {
      icon: <ActivityIcon fontSize="small" />,
      label: 'Activity',
      value: 3,
    },
    HOLDERS_TAB: {
      icon: <HoldersIcon fontSize="small" />,
      label: 'Holders',
      value: 4,
    },
  },
};

export const ACTIVITY_TABLE_COLUMNS = [
  {
    field: 'activity',
    label: 'Event',
    sx: { position: 'sticky', left: 0, zIndex: 5, pl: 0 },
  },
  { field: 'item', label: 'Item' },
  { field: 'price', label: 'Price', sx: { textAlign: 'right' } },
  { field: 'from', label: 'From', sx: { pl: 6, textAlign: 'right' } },
  { field: 'to', label: 'To', sx: { textAlign: 'right' } },
  { field: 'time', label: 'Time', sx: { textAlign: 'right' } },
];

export const LISTING_DURATIONS = [
  {
    key: '1 Hour',
    value: 1,
  },
  {
    key: '1 Day',
    value: 1 * 24,
  },
  {
    key: '3 Days',
    value: 3 * 24,
  },
  {
    key: '7 Days',
    value: 7 * 24,
  },
  {
    key: '30 Days',
    value: 30 * 24,
  },
  {
    key: '6 Months',
    value: 180 * 24,
  },
];

export const RARITIES_PERCENTILE = {
  mythic: 'Top 1%',
  legendary: 'Top 3%',
  epic: 'Top 10%',
  rare: 'Top 25%',
  uncommon: 'Top 50%',
  common: 'Bottom 50%',
};

export const PORTFOLIO_FILTER = ['Show All', 'Only Listed'];

export const PORTFOLIO_TABS = {
  Items: 'Items',
  Activity: 'Activity',
  Offers: 'Offers',
  Bids: 'Bids',
};

export const ORDER_TYPES = {
  LISTING: 'listing',
  OFFER: 'offer',
};

export const SOMETHING_WENT_WRONG = 'Something went wrong. Please try again later';

export const CATEGORY_OPTIONS = ['Art', 'Gaming', 'Membership', 'PFPs', 'Photography', 'Music'];

export const SOCIAL_LINKS = [
  {
    name: 'twitterUsername',
    adornment: 'https://x.com/',
    placeholder: 'my-first-collection',
    icon: <X />,
  },
  {
    name: 'instagramUsername',
    adornment: 'https://www.instagram.com/',
    placeholder: 'my-first-collection',
    icon: <Instagram />,
  },
  {
    name: 'discordUrl',
    placeholder: 'https://discord.gg/handle',
    icon: <DiscordNewIcon color="#929292" />,
  },
  { name: 'externalUrl', placeholder: 'https://yoursite.xyz', icon: <Language /> },
];

/**
 * The maximum number of NFTs that can be processed in a single transaction.
 * due to 40_000_000 max chain gas limit
 */
export const MAXIMUM_NFT_LIMIT = {
  // 1 mint is around 200_000 to 300_000 gas
  MINTS: 260,
  // 1 sweep item is around 600_000 to 700_000 gas
  SWEEPS: 60,
  // 1 bid item is around 850_000 to 950_000 gas
  BIDS: 40,
};

export const WALLET_OPTIONS = [
  {
    name: 'MetaMask',
    icon: <MetamaskIcon />,
  },
  {
    name: 'Coinbase Wallet',
    icon: <CoinBaseIcon />,
  },
];

export const MAX_FILE_SIZE = {
  label: '10 MB',
  value: 10 * 1024 * 1024,
};

export const METAMASK_DOWNLOAD_URL = 'https://metamask.io/download.html';

export const METAMASK_GUIDE_URL =
  'https://wiki.energi.world/docs/quickstart/getting-started-with-metamask';

// Networks available for LP Bonds selection
export const NETWORK_SELECTION = [
  {
    value: 'energi',
    label: 'Energi',
    icon: <NRGChromeIcon color="#00E676" />,
    isExternal: true,
    url: 'https://app.gonnamakeit.com',
  },
  {
    value: SUPPORTED_NETWORKS.Ethereum,
    label: 'Ethereum',
    icon: <EthNewIcon />,
  },
  {
    value: SUPPORTED_NETWORKS.Abstract,
    label: 'Abstract',
    icon: <AbstractSymbol sx={{ padding: '4px' }} />,
  },
  {
    value: SUPPORTED_NETWORKS.ApeChain,
    label: 'ApeChain',
    icon: <ApeChainSymbolNew sx={{ padding: '4px' }} />,
  },
  {
    value: SUPPORTED_NETWORKS.Arbitrum,
    label: 'Arbitrum',
    icon: <ArbitrumSymbolNew sx={{ padding: '4px' }} />,
  },
  {
    value: SUPPORTED_NETWORKS.Base,
    label: 'Base',
    icon: <BaseSymbol sx={{ padding: '4px' }} />,
  },
  {
    value: SUPPORTED_NETWORKS.Bsc,
    label: 'BSC',
    icon: <BinanceSymbol />,
  },
  {
    value: SUPPORTED_NETWORKS.Monad,
    label: 'Monad',
    icon: <MonadSymbolFilled />,
  },
];

const ClockHeadingIcon = styled(AccessTimeIcon)(() => ({
  verticalAlign: 'middle',
  width: 20,
  height: 20,
}));

export const LIST_TABLE_COLUMNS = [
  { id: 'item', label: 'Item' },
  { id: 'rarity', label: 'Rarity', props: { textAlign: 'right' } },
  { id: 'buyNow', label: 'Buy Now', props: { textAlign: 'right' } },
  { id: 'lastSale', label: 'Last Sale', props: { textAlign: 'right' } },
  { id: 'owner', label: 'Owner', props: { textAlign: 'right' } },
  {
    id: 'time',
    label: (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <ClockHeadingIcon />
      </Box>
    ),
    props: { textAlign: 'right' },
  },
];

export const LIST_TABLE_BOND_COLUMNS = [
  { id: 'item', label: 'Bond ID', type: 'bondId', props: { textAlign: 'left' } },
  { id: 'price', label: 'Price', type: 'price', props: { textAlign: 'right' } },
  { id: 'bid', label: 'Bid', type: 'bid', props: { textAlign: 'right' } },
  {
    id: 'rewardsAccrued',
    label: 'Rewards Accrued',
    type: 'rewards',
    props: { textAlign: 'right' },
  },
  { id: 'tvl', label: 'TVL', type: 'tvl', props: { textAlign: 'right' } },
  { id: 'apy', label: 'APR', type: 'apy', props: { textAlign: 'right' } },
  { id: 'age', label: 'Age', type: 'age', props: { textAlign: 'right' } },
  {
    id: 'durationLeft',
    label: 'Maturity Date',
    type: 'left',
    props: { textAlign: 'right' },
  },
  { id: 'holders', label: 'Holders', type: 'holders', props: { textAlign: 'right' } },
];
